interface CustomAttachMoneyAltIconProps {
    className?: string;
    dollarSignColor?: string;
}

export const CustomAttachMoneyAltIcon = ({ className, dollarSignColor = 'black' }: CustomAttachMoneyAltIconProps) => (
    <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className || ''}
    >
        <path
            d="M10.0208 15.7083V17.5H11.6875V15.75C12.1939 15.6765 12.6522 15.5358 13.0625 15.3278C12.1792 14.8178 11.8611 14.2765 11.8125 14.0696C11.5705 14.1343 11.3066 14.1667 11.0208 14.1667C10.3542 14.1667 9.81597 13.9931 9.40625 13.6458C8.99653 13.2986 8.6875 12.7917 8.47917 12.125L6.9375 12.75C7.1875 13.6111 7.57986 14.2778 8.11458 14.75C8.64931 15.2222 9.28472 15.5417 10.0208 15.7083Z"
            fill={dollarSignColor}
            fillOpacity="0.9"
        />
        <path
            d="M8.02083 9.11458C8.46528 9.63542 9.28472 10.0833 10.4792 10.4583C11.0185 10.6336 11.463 10.7999 11.8125 10.9572C11.9653 10.6502 12.4292 9.96031 13.0625 9.65618C12.7026 9.43929 12.2859 9.26223 11.8125 9.125C10.7847 8.83333 10.0625 8.55556 9.64583 8.29167C9.22917 8.02778 9.02083 7.66667 9.02083 7.20833C9.02083 6.80556 9.18056 6.46875 9.5 6.19792C9.81944 5.92708 10.2847 5.79167 10.8958 5.79167C11.4236 5.79167 11.8403 5.90278 12.1458 6.125C12.4514 6.34722 12.6875 6.68056 12.8542 7.125L14.3958 6.45833C14.1875 5.88889 13.8576 5.40625 13.4062 5.01042C12.9549 4.61458 12.3819 4.36111 11.6875 4.25V2.5H10.0208V4.25C9.40972 4.31944 8.8125 4.60417 8.22917 5.10417C7.64583 5.60417 7.35417 6.30556 7.35417 7.20833C7.35417 7.95833 7.57639 8.59375 8.02083 9.11458Z"
            fill={dollarSignColor}
            fillOpacity="0.9"
        />
        <path
            d="M15.8333 13.3333V15.8333H17.5V13.3333H20V11.6667H17.5V9.16667H15.8333V11.6667H13.3333V13.3333H15.8333Z"
            fill={dollarSignColor}
            fillOpacity="0.9"
        />
        <path
            d="M15.8335 13.3334V15.8334H17.5002V13.3334H20.0002V11.6667H17.5002V9.16669H15.8335V11.6667H13.3335V13.3334H15.8335Z"
            fill="#0AC285"
        />
    </svg>
);
